import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { CreateJobPostDataType } from '../../models/jobs/createJobPost.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import useHttps from '../useHttps';
import { useAppDisPatch } from '../../redux/store';
import { jobCreatedListActions } from '../../redux/slices/jobCreatedListSlice';
import { useNavigate } from 'react-router';
import { JOBS } from '../../routes/routeConstants';
import { useContext } from 'react';
import { ModalContext } from '../../context/ModalContext';

const useCreateJobPost = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const navigate = useNavigate();

  const modalContext = useContext(ModalContext);


  const onCreateJobPostError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ?? 'Something went wrong while creating job'
    );
  };

  const onCreateJobPostSuccess =
    (resetFormFn: (...args: any) => void) =>
    ({ data, message }: SuccessHttpResponse<any>) => {
      toast.success(message);
      // Automatically update the created jobs list with the new job data.
      dispatch(jobCreatedListActions.addJob(data));
      resetFormFn();
      navigate(`/${JOBS}`);
      modalContext?.displayModal(false);
    };

  const createJobPost = (
    data: CreateJobPostDataType,
    resetFormFn: (...args: any) => void
  ) => {
    // Convert pay and yearsOfExperience to numbers
    const payload = {
      ...data,
      pay: Number(data.pay),
      yearsOfExperience: Number(data.yearsOfExperience),
    };

    const url: HttpConfig = {
      url: `jobs-service/jobs`,
      method: 'post',
      data: payload,
    };

    request(
      url,
      onCreateJobPostSuccess(resetFormFn),
      setLoading,
      onCreateJobPostError
    );
  };

  return { createJobPost, loading };
};

export default useCreateJobPost;
